import { render, staticRenderFns } from "./FormulairePaiement.vue?vue&type=template&id=00cbda75&scoped=true"
import script from "./FormulairePaiement.vue?vue&type=script&lang=js"
export * from "./FormulairePaiement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cbda75",
  null
  
)

export default component.exports